import request from '@/utils/request';

// 获取助力活动详情
export const activityHelpactivityHelpInfo = (data: any): any =>
request({
  url: '/pc/activityHelp/activityHelpInfo',
  data: data
})
// 助力活动保存
export const activityHelpactivityHelpSave = (data: any): any =>
request({
  url: '/pc/activityHelp/activityHelpSave',
  data: data
})
// 直播间-商品库-初始化
export const liveRoomProductRepositoryinit = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/init',
  data: data
})
// 直播间-商品库-列表
export const liveRoomProductRepositorylist = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/list',
  data: data
})
// 直播间-商品库-撤回审核
export const liveRoomProductRepositoryrevoke = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/revoke',
  data: data
})
// 直播间-商品库-删除
export const liveRoomProductRepositorydelete = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/delete',
  data: data
})
// 直播间-商品库-重新提交审核
export const liveRoomProductRepositoryresubmit = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/resubmit',
  data: data
})
// 直播间-商品库-选择商品列表
export const liveRoomProductRepositorychooseProductList = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/chooseProductList',
  data: data
})
// 直播间-商品库-添加并提交审核
export const liveRoomProductRepositoryaddAndSubmit = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/addAndSubmit',
  data: data
})
// 直播间-商品库-再次提交审核（需要刷新列表）
export const liveRoomProductRepositorysubmitAgain = (data: any): any =>
request({
  url: '/pc/liveRoomProductRepository/submitAgain',
  data: data
})

// 直播间-商品库-获取直播助力活动数据
export const activityHelpactivityHelpLiveData = (data: any): any =>
request({
  url: '/pc/activityHelp/activityHelpLiveData',
  data: data
})
// 直播间-列表
export const liveRoomlist = (data: any): any =>
request({
  url: '/pc/liveRoom/list',
  data: data
})
// 直播间-数据统计
export const liveRoomdataStatistics = (data: any): any =>
request({
  url: '/pc/liveRoom/dataStatistics',
  data: data
})
// 直播间-同步获取最新直播间
export const liveRoomsync = (data: any): any =>
request({
  url: '/pc/liveRoom/sync',
  data: data
})
// 直播间商品-列表
export const liveRoomProductlist = (data: any): any =>
request({
  url: '/pc/liveRoomProduct/list',
  data: data
})
// 直播间商品-选择商品库商品
export const liveRoomProductchooseRepositoryList = (data: any): any =>
request({
  url: '/pc/liveRoomProduct/chooseRepositoryList',
  data: data
})
// 直播间商品-上下架
export const liveRoomProductonSale = (data: any): any =>
request({
  url: '/pc/liveRoomProduct/onSale',
  data: data
})
// 直播间商品-保存
export const liveRoomProductbatchEdit = (data: any): any =>
request({
  url: '/pc/liveRoomProduct/batchEdit',
  data: data
})
// 直播间商品-加入直播间
export const liveRoomProductrepositoryJoin = (data: any): any =>
request({
  url: '/pc/liveRoomProduct/repositoryJoin',
  data: data
})
// 直播间-删除
export const liveRoomdelete = (data: any): any =>
request({
  url: '/pc/liveRoom/delete',
  data: data
})

export const liveRoomEdit = (data: any): any =>
request({
  url: '/pc/liveRoom/edit',
  data: data
})

// 报名活动列表
export const activitySignUpactivitySignUpPageInit = (data: any): any =>
request({
  url: '/pc/activitySignUp/activitySignUpPageInit',
  data: data
})
// 报名活动列表删除
export const activitySignUpdelete = (data: any): any =>
request({
  url: '/pc/activitySignUp/delete',
  data: data
})
// 报名活动列表 修改序号
export const activitySignUpsortEdit = (data: any): any =>
request({
  url: '/pc/activitySignUp/sortEdit',
  data: data
})
// 报名活动列表 修改是否显示
export const activitySignUpisDisplaySave = (data: any): any =>
request({
  url: '/pc/activitySignUp/isDisplaySave',
  data: data
})
// 报名活动列表 详情
export const activitySignUpinfo = (data: any): any =>
request({
  url: '/pc/activitySignUp/info',
  data: data
})
// 报名活动列表 保存
export const activitySignUpsave = (data: any): any =>
request({
  url: '/pc/activitySignUp/save',
  data: data
})


// 报名活动列表 查看报名信息
export const activitySignUpsignUpRecord = (data: any): any =>
request({
  url: '/pc/activitySignUp/signUpRecord',
  data: data
})



// 获取大转盘抽奖列表
export const activityWheelSurfactivityWheelSurf = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfPageInit',
  data: data
})
// 修改状态
export const activityWheelSurfactivityWheelSurfIsOpenEdit = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfIsOpenEdit',
  data: data
})
// 删除大转盘活动
export const activityWheelSurfactivityWheelSurfDelete = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfDelete',
  data: data
})
// 获取大转盘活动信息
export const activityWheelSurfactivityWheelSurfInfo = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfInfo',
  data: data
})
// 保存大转盘活动信息
export const activityWheelSurfactivityWheelSurfSave = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfSave',
  data: data
})
// 获取大转盘活动抽奖数据统计
export const activityWheelSurfprizesDrawnedDatatatistics = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/prizesDrawnedDatatatistics',
  data: data
})
// 获取抽奖活动奖项奖品名称
export const activityWheelSurfactivityWheelSurfPrizeName = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfPrizeName',
  data: data
})

// 查看抽奖信息
export const activityWheelSurfprizesDrawnedDataPageInit = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/prizesDrawnedDataPageInit',
  data: data
})
// 奖励失效
export const activityWheelSurfinvalidPrize = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/invalidPrize',
  data: data
})
// 实物奖-导入发货 
export const activityWheelSurfactivityWheelSurfRewardSendImport = (data: any): any =>
request({
  url: '/pc/activityWheelSurf/activityWheelSurfRewardSendImport',
  data: data
})

// 支付有礼活动列表
export const activityPayGiftactivityPayGiftPageInit = (data: any): any =>
request({
  url: '/pc/activityPayGift/activityPayGiftPageInit',
  data: data
})
// 修改支付有礼状态
export const activityPayGiftactivityPayGiftIsOpenEdit = (data: any): any =>
request({
  url: '/pc/activityPayGift/activityPayGiftIsOpenEdit',
  data: data
})
// 删除支付有礼活动
export const activityPayGiftactivityPayGiftDelete = (data: any): any =>
request({
  url: '/pc/activityPayGift/activityPayGiftDelete',
  data: data
})
// 支付有礼活动数据
export const activityPayGiftactivityPayGiftData = (data: any): any =>
request({
  url: '/pc/activityPayGift/activityPayGiftData',
  data: data
})
// 支付有礼活动信息
export const activityPayGiftactivityPayGiftInfo = (data: any): any =>
request({
  url: '/pc/activityPayGift/activityPayGiftInfo',
  data: data
})
// 支付有礼活动保存
export const activityPayGiftactivityPayGiftSave = (data: any): any =>
request({
  url: '/pc/activityPayGift/activityPayGiftSave',
  data: data
})


// 获取签到活动列表
export const activityDailyCheckactivityDailyCheckPageInit = (data: any): any =>
request({
  url: '/pc/activityDailyCheck/activityDailyCheckPageInit',
  data: data
})
// 活动删除
export const activityDailyCheckactivityDailyCheckDelete = (data: any): any =>
request({
  url: '/pc/activityDailyCheck/activityDailyCheckDelete',
  data: data
})
// 修改状态
export const activityDailyCheckactivityDailyCheckIsOpenEdit = (data: any): any =>
request({
  url: '/pc/activityDailyCheck/activityDailyCheckIsOpenEdit',
  data: data
})
// 活动数据
export const activityDailyCheckactivityDailyCheckData = (data: any): any =>
request({
  url: '/pc/activityDailyCheck/activityDailyCheckData',
  data: data
})
// 获取签到活动信息
export const activityDailyCheckactivityDailyCheckInfo = (data: any): any =>
request({
  url: '/pc/activityDailyCheck/activityDailyCheckInfo',
  data: data
})
// 签到活动保存
export const activityDailyCheckactivityDailyCheckSave = (data: any): any =>
request({
  url: '/pc/activityDailyCheck/activityDailyCheckSave',
  data: data
})
// 作废优惠券
export const activitycouponmemberCouponCancel = (data: any): any =>
	request({
		url: '/pc/activitycoupon/memberCouponCancel',
		data: data
})
// 购物金导入记录
export const memberCommissionImportRecordmemberCommissionImportRecordPageInit = (data: any): any =>
	request({
		url: '/pc/memberCommissionImportRecord/memberCommissionImportRecordPageInit',
		data: data
})
// 导入数据明细
export const memberCommissionImportRecordmemberCommissionImportRecordData = (data: any): any =>
	request({
		url: '/pc/memberCommissionImportRecord/memberCommissionImportRecordData',
		data: data
})
// 导入购物金
export const memberCommissionImportRecordmemberCommissionImport = (data: any): any =>
	request({
		url: '/pc/memberCommissionImportRecord/memberCommissionImport',
		data: data
})




// 任务奖励活动列表
export const activityTaskRewardactivityTaskRewardPageInit = (data: any): any =>
	request({
		url: '/pc/activityTaskReward/activityTaskRewardPageInit',
		data: data
})
// 任务奖励活动删除
export const activityTaskRewardactivityTaskRewardDelete = (data: any): any =>
	request({
		url: '/pc/activityTaskReward/activityTaskRewardDelete',
		data: data
})
// 任务奖励活动开启-关闭
export const activityTaskRewardactivityTaskRewardIsOpenUpdate = (data: any): any =>
	request({
		url: '/pc/activityTaskReward/activityTaskRewardIsOpenUpdate',
		data: data
})
// 任务奖励活动明细
export const activityTaskRewardactivityTaskRewardDetail = (data: any): any =>
	request({
		url: '/pc/activityTaskReward/activityTaskRewardDetail',
		data: data
})
// 任务奖励活动保存
export const activityTaskRewardactivityTaskRewardSave = (data: any): any =>
	request({
		url: '/pc/activityTaskReward/activityTaskRewardSave',
		data: data
})
// 奖励活动数据
export const activityTaskRewardactivityTaskRewardData = (data: any): any =>
	request({
		url: '/pc/activityTaskReward/activityTaskRewardData',
		data: data
})


// 换购活动列表 
export const activityExchangeBuyactivityExchangeBuyPageInit = (data: any): any =>
	request({
		url: '/pc/activityExchangeBuy/activityExchangeBuyPageInit',
		data: data
})
// 活动开启关闭 
export const activityExchangeBuyactivityExchangeBuyIsOpenUpdate = (data: any): any =>
	request({
		url: '/pc/activityExchangeBuy/activityExchangeBuyIsOpenUpdate',
		data: data
})
// 活动删除 
export const activityExchangeBuyactivityExchangeBuyDelete = (data: any): any =>
	request({
		url: '/pc/activityExchangeBuy/activityExchangeBuyDelete',
		data: data
})
// 换购活动保存 
export const activityExchangeBuyactivityExchangeBuySave = (data: any): any =>
	request({
		url: '/pc/activityExchangeBuy/activityExchangeBuySave',
		data: data
})
// 换购活动详情 
export const activityExchangeBuyactivityExchangeBuyInfo = (data: any): any =>
	request({
		url: '/pc/activityExchangeBuy/activityExchangeBuyInfo',
		data: data
})
// 活动数据 
export const activityExchangeBuyactivityExchangeBuyData = (data: any): any =>
	request({
		url: '/pc/activityExchangeBuy/activityExchangeBuyData',
		data: data
})


// 邀友有礼列表 
export const activityInviteFriendlist = (data: any): any =>
	request({
		url: '/pc/activityInviteFriend/list',
		data: data
})
// 邀友有礼删除 
export const activityInviteFrienddelete = (data: any): any =>
	request({
		url: '/pc/activityInviteFriend/delete',
		data: data
})
// 邀友有礼活动轮播图列表 
export const activityInviteFriendCarouselImagelist = (data: any): any =>
	request({
		url: '/pc/activityInviteFriendCarouselImage/list',
		data: data
})
// 邀友有礼开启关闭 
export const activityInviteFriendchangeIsOpen = (data: any): any =>
	request({
		url: '/pc/activityInviteFriend/changeIsOpen',
		data: data
})
// 邀友有礼活动轮播图保存 
export const activityInviteFriendCarouselImagesave = (data: any): any =>
	request({
		url: '/pc/activityInviteFriendCarouselImage/save',
		data: data
})
// 邀友有礼活动轮播图删除  
export const activityInviteFriendCarouselImagedelete = (data: any): any =>
	request({
		url: '/pc/activityInviteFriendCarouselImage/delete',
		data: data
})
// 邀友有礼活动轮播图数据  
export const activityInviteFriendCarouselImageedit = (data: any): any =>
	request({
		url: '/pc/activityInviteFriendCarouselImage/edit',
		data: data
})
// 邀友有礼活动数据列表   
export const activityInviteFrienddataList = (data: any): any =>
	request({
		url: '/pc/activityInviteFriend/dataList',
		data: data
})
// 邀友有礼数据   
export const activityInviteFriendedit = (data: any): any =>
	request({
		url: '/pc/activityInviteFriend/edit',
		data: data
})
// 邀友有礼保存 
export const activityInviteFriendsave = (data: any): any =>
	request({
		url: '/pc/activityInviteFriend/save',
		data: data
})

//随心选-列表
export const activityOnePriceActivityOnePriceList = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOnePriceList',
		data: data
})
//随心选-删除
export const activityOnePriceActivityOnePriceDelete = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOnePriceDelete',
		data: data
})
//随心选-活动数据
export const activityOnePriceActivityOnePriceOrderList = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOnePriceOrderList',
		data: data
})
//批量获取商品规格信息
export const activityOnePriceActivityOneChoosePriceProductList = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOneChoosePriceProductList',
		data: data
})
//随心选-保存
export const activityOnePriceActivityOnePriceSave = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOnePriceSave',
		data: data
})
//随心选-获取活动信息
export const activityOnePriceActivityOnePriceInfo = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOnePriceInfo',
		data: data
})
export const activityOnePriceActivityOneChooseProductVerify = (data: any): any =>
	request({
		url: '/pc/activityOnePrice/activityOneChooseProductVerify',
		data: data
})

// 锦鲤活动
export const activityKoiFishlist = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/list',
		data: data
})
export const activityKoiFishlsave = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/save',
		data: data
})
export const activityKoiFishlisOpenEdit = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/isOpenEdit',
		data: data
})
export const activityKoiFishlidelete = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/delete',
		data: data
})
export const activityKoiFishliinfo = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/info',
		data: data
})
export const activityKoiFishorderList = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/orderList',
		data: data
})
export const activityKoiFishPrizeName = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/activityKoiFishPrizeName',
		data: data
})
export const activityKoiFishMemberKoiFishWinnerList = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/activityKoiFishMemberKoiFishWinnerList',
		data: data
})
export const activityKoiFishRewardSendImport = (data: any): any =>
	request({
		url: '/pc/activityKoiFish/activityKoiFishRewardSendImport',
		data: data
})